const translation = {
  input: 'GİRİŞ',
  result: 'SONUÇ',
  detail: 'DETAY',
  tracing: 'İZLEME',
  resultPanel: {
    status: 'DURUM',
    time: 'GEÇEN ZAMAN',
    tokens: 'TOPLAM TOKEN',
  },
  meta: {
    title: 'METADATA',
    status: 'Durum',
    version: 'Sürüm',
    executor: 'Yürütücü',
    startTime: 'Başlama Zamanı',
    time: 'Geçen Zaman',
    tokens: 'Toplam Token',
    steps: 'Çalıştırma Adımları',
  },
  resultEmpty: {
    title: 'Bu çalıştırma sadece JSON formatında çıktı verdi,',
    tipLeft: 'lütfen ',
    link: 'detay paneli',
    tipRight: 'ne gidin ve görüntüleyin.',
  },
  actionLogs: 'Eylem Günlükleri',
  circularInvocationTip: 'Geçerli iş akışında araçların/düğümlerin döngüsel olarak çağrılması vardır.',
}

export default translation
